import { createStore, combineReducers } from 'redux';
import loaderReducer from './reducers/stateReducers';
const rootReducers = combineReducers({loaderReducer})
export default createStore(rootReducers);